import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/marketing",
    name: "marketing",
    component: dashboard,
    redirect: {
      name: "endApplication"
    },
    children: [
      {
        path: "endApplication",
        name: "endApplication",
        meta: { title: "已终止的二维码" },
        component: () => import("@/views/marketingEnd/index.vue"),
        children: [
          {
            path: "marketingTimeInfo/:marketingId;:number;:marketingName",
            name: "marketingTimeInfo",
            meta: { title: "拍码统计" },
            component: () =>
              import("@/views/marketingEnd/marketingTimeindex.vue"),
            children: []
          }
        ]
      }
    ]
  }
];
